import button from './ImportButton.vue'
const ImportButton = {
  install: function (Vue) {
    Vue.component('ImportButton', button)
  }
}
export default ImportButton
